<template>
  <div
    class="doctor-list-main-wrapper cbg-white-container input-container theme--light v-card p-16 border-card"
  >
    <CRow v-if="!showAlliedProfile">
      <CCol sm="12">
        <CRow>
          <CCol sm="3">
            <div class="common-search">
              <CInput
                label="Search by Name"
                v-model="search"
                placeholder="Name"
              />
              <div
                v-if="search !== ''"
                class="cross-svg position-absolute"
                @click="clearSearch()"
              >
                <crossSVG />
              </div>
            </div>
          </CCol>
          <CCol sm="3">
            <div class="position-relative">
              <CSelect
                label="Per page"
                @update:value="udpateRecordPerPage"
                :options="perPageOptions"
              />
              <span class="drop-icon">
                <i
                  aria-hidden="true"
                  class="v-icon mdi mdi-menu-down theme--light position-absolute"
                ></i>
              </span>
            </div>
          </CCol>
          <CCol sm="3">
            <div class="position-relative">
              <CSelect
                label="Filter by status"
                @update:value="udpateStatus"
                :options="statusOptions"
                v-model="status"
              />
              <span class="drop-icon">
                <i
                  aria-hidden="true"
                  class="v-icon mdi mdi-menu-down theme--light position-absolute"
                ></i>
              </span>
            </div>
          </CCol>
          <CCol sm="3">
            <label for>&nbsp;</label>
            <div class="mt-2">
              <v-btn
                @click="downloadCsv()"
                class="btn btn-primary"
                :disabled="exportLoading"
                >{{ exportLoading ? "Exporting..." : "Export" }}</v-btn
              >
            </div>
          </CCol>
        </CRow>
      </CCol>
      <CCol sm="12">
        <!-- <CTableWrapper fixed bordered caption="Bordered Table" /> -->

        <div  class="col-sm-12">
          <table class="table userlistTable ww-100">
            <thead>
              <tr class="table-success">
                <th scope="col">Name</th>
                <th scope="col">City</th>
                <th scope="col">Status</th>
                <th scope="col">Requested on</th>
                <th scope="col" class="small-min-width-120">Verified by</th>
                <th class="text-center" scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="allied in alliedData" :key="allied._id">
                <th class="text-capitalize">
                  {{ allied.allied_id.full_name }}
                  <br />
                  <small
                    class="text-muted"
                    v-if="
                      allied.allied_id.allied &&
                        allied.allied_id.allied.highest_qualification.length
                    "
                    >{{
                      allied.allied_id.allied.highest_qualification.join()
                    }}</small
                  >
                </th>
                <td>
                  {{
                    allied &&
                    allied.allied_id &&
                    allied.allied_id.address &&
                    allied.allied_id.address.current_address &&
                    allied.allied_id.address.current_address.city
                      ? allied.allied_id.address.current_address.city
                      : "N/A"
                  }}
                </td>
                <td>
                  <span v-if="allied.current_document_status == 'PENDING'">
                    <span class="badge badge-warning">Pending</span>
                    <InfoIconSVG
                      v-if="checkRequestWasRejected(allied.histories)"
                      v-c-tooltip.hover.click="
                        'This request was previously rejected. View log to see more details.'
                      "
                      class="info-icon iconwidth ml-3"
                    />
                  </span>
                  <span
                    class="badge badge-success"
                    v-else-if="allied.current_document_status == 'APPROVED'"
                    >Approved</span
                  >
                  <span
                    class="badge badge-danger"
                    v-else-if="allied.current_document_status == 'NOT_UPLOADED'"
                    >Not Uploaded</span
                  >
                  <span class="badge badge-danger" v-else>Rejected</span>
                </td>
                <td>{{ moment(allied.createdAt) }}</td>
                <td>
                  <span
                    v-if="
                      allied.current_document_status == 'PENDING' ||
                        allied.current_document_status == 'NOT_UPLOADED'
                    "
                    >N/A</span
                  >
                  <span
                    v-else-if="allied.current_document_status == 'APPROVED'"
                  >
                    {{
                      `${
                        allied.approved_details.aprroved_by_admin
                          ? allied.approved_details.aprroved_by_admin.first_name
                          : ""
                      } ${
                        allied.approved_details.aprroved_by_admin
                          ? allied.approved_details.aprroved_by_admin.last_name
                          : ""
                      }`
                    }}
                    <br />
                    <small class="text-muted">{{
                      moment(allied.approved_details.approved_on)
                    }}</small>
                  </span>
                  <span v-else-if="allied.current_document_status == 'REJECT'">
                    {{
                      allied.rejected_details.rejected_by_admin
                        ? `${allied.rejected_details.rejected_by_admin.first_name} ${allied.rejected_details.rejected_by_admin.last_name}`
                        : ""
                    }}
                    <br />
                    <small class="text-muted">{{
                      moment(allied.rejected_details.rejected_on)
                    }}</small>
                  </span>
                </td>
                <td>
                  <div
                    class="d-flex justify-content-end pr-8 small-table-padding"
                  >
                    <div
                      v-if="!(allied.current_document_status == 'NOT_UPLOADED')"
                      class="my-3 mr-2"
                    >
                      <CButton
                        class="text-uppercase text-no-wrap"
                        block
                        variant="outline"
                        color="success"
                        @click="$refs.AlliedLogModal.viewModal(allied)"
                        v-if="
                          permissions.includes(
                            'CAN_VIEW_HISTORY_DOCTOR_APPROVAL'
                          )
                        "
                        :disabled="
                          allied &&
                            allied.histories &&
                            allied.histories.length == 1
                        "
                        >View Log</CButton
                      >
                    </div>
                    <div class="my-3 mb-xl-0">
                      <CButton
                        :disabled="!allied.registration_proof_image_url"
                        block
                        variant="outline"
                        color="success"
                        @click="verifyDoctor(allied)"
                        v-if="
                          allied.current_document_status == 'APPROVED' &&
                            permissions.includes(
                              'CAN_VIEW_DOCUMENT_DOCTOR_APPROVAL'
                            )
                        "
                        >View</CButton
                      >
                      <CButton
                        class="text-uppercase"
                        :disabled="!allied.registration_proof_image_url"
                        block
                        variant="outline"
                        color="success"
                        @click="verifyDoctor(allied)"
                        v-else-if="
                          allied.current_document_status == 'PENDING' &&
                            permissions.includes(
                              'CAN_APPROVE_REJECT_DOCTOR_APPROVAL'
                            )
                        "
                        >Verify</CButton
                      >
                      <CButton
                        block
                        variant="outline"
                        color="danger"
                        @click="verifyDoctor(allied)"
                        v-else-if="
                          allied.current_document_status == 'NOT_UPLOADED' &&
                            permissions.includes(
                              'CAN_APPROVE_REJECT_DOCTOR_APPROVAL'
                            )
                        "
                        >Reject</CButton
                      >
                      <CButton
                        block
                        variant="outline"
                        color="danger"
                        @click="verifyDoctor(allied)"
                        v-else-if="
                          allied.current_document_status == 'REJECT' &&
                            permissions.includes(
                              'CAN_VIEW_DOCUMENT_DOCTOR_APPROVAL'
                            )
                        "
                        >Reason</CButton
                      >
                    </div>
                    <div class="my-3 mb-xl-0 contact-div d-flex">
                      <div>
                        <CDropdown
                          color="link"
                          size="lg"
                          :caret="false"
                          class="dropdowndocbox"
                        >
                          <template #toggler-content>
                            <verticalDotsSVG />
                          </template>
                          <CDropdownItem @click="getViewDetails(allied)"
                            >View Details</CDropdownItem
                          >
                          <CDropdownItem>Call</CDropdownItem>
                          <CDropdownItem>Deactivate</CDropdownItem>
                          <CDropdownItem
                            @click="
                              goToChat(
                                allied.allied_id._id,
                                allied.allied_id.full_name
                              )
                            "
                            >Chat</CDropdownItem
                          >
                          <CDropdownItem
                            v-if="allied.email != ''"
                            :href="`mailto:${allied.email}`"
                            >Email</CDropdownItem
                          >
                        </CDropdown>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <pagination
          v-if="alliedData && alliedData.length"
          class="mx-1 mob-t-center pagination-block"
          :recordPerPage="recordPerPage"
          :currentPage="currentPage"
          :total="total"
          @changePage="changePage"
        />
      </CCol>
    </CRow>
    <VerifyAlliedModal ref="VerifyAlliedModal" @refreshList="getDoctors" />
    <AlliedLogModal
      ref="AlliedLogModal"
      @showVerifyModal="viewAlliedDocument"
    />
    <CRow v-if="showAlliedProfile">
      <CCol sm="12" class="p-0">
        <allied-profile-summary-details
          v-if="showAlliedProfile"
          @close="closeProfile()"
          :userId="userId"
        ></allied-profile-summary-details>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import InfoIconSVG from "@/views/SVG/InfoIconSVG";
import config from "@/config.js";
const VerifyAlliedModal = () => import("./Modals/VerifyAlliedModal");
const AlliedLogModal = () => import("./Modals/AlliedLogModal");
import formats from "@/formats";
import moment from "moment";
import debounce from "lodash/debounce";
import { pickSvg } from "@/views/SVG";
import ChatMixin from "@/common/ChatMixin";
import { mapGetters } from "vuex";
export default {
  mixins: [ChatMixin],
  watch: {
    recordPerPage: function(val) {
      this.getSearchResult();
    },
    search: function(val) {
      this.getSearchResult();
    },
    status: function(val) {
      this.getSearchResult();
    },
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },
  data() {
    return {
      exportLoading: false,
      VerifyAlliedModal: false,
      viewLogModal: false,
      verifyDoctorReasonModal: false,
      approveConfirmation: false,
      GiveRejectReason: false,
      rejectApprove: true,
      alliedData: [],
      search: "",
      recordPerPage: 10,
      status: "PENDING",
      currentPage: 1,
      totalPage: 0,
      perPageOptions: [10, 20, 30, 50, 100],
      statusOptions: [
        { value: "ALL", label: "All" },
        { value: "PENDING", label: "Pending" },
        { value: "APPROVED", label: "Approved" },
        { value: "REJECT", label: "Rejected" },
        { value: "NOT_UPLOADED", label: "Not Uploaded" },
      ],
      total: 0,
      showAlliedProfile: false,
      userId: "",
    };
  },
  components: {
    InfoIconSVG,
    VerifyAlliedModal,
    AlliedLogModal,
    "allied-profile-summary-details": () =>
      import("@/views/dashboardNew/userListing/alliedProfileSummaryDetails"),
    ...pickSvg("messageSVG", "phoneSVG", "emailSVG"),
    pagination: () => import("@/views/common/Pagination"),
  },
  methods: {
    downloadCsv() {
      this.exportLoading = true;
      let url = `${config.BASE_URL}api/v2/admin/allied-list/export`;
      let payload = {
        status: this.status,
        search_text: this.search,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          if (res.body.status) {
            const downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(
              new Blob(["\ufeff", res.body.data.csvString])
            );
            downloadLink.download = "allied-approval-list.csv";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    clearSearch() {
      this.search = "";
    },
    confirmationAppoval() {
      this.rejectApprove = false;
      this.approveConfirmation = true;
    },
    cancelApprovation() {
      this.rejectApprove = true;
      this.approveConfirmation = false;
    },
    rejectapproval() {
      this.GiveRejectReason = true;
      this.rejectApprove = false;
    },
    cancelRejectReason() {
      this.GiveRejectReason = false;
      this.rejectApprove = true;
    },
    getSearchResult: debounce(function(e) {
      this.alliedData = [];
      this.currentPage = 1;
      this.getDoctors();
    }, 800),
    getDoctors() {
      let url = `${config.BASE_URL}api/v2/admin/allied-list`;
      let payload = {
        status: this.status,
        search_text: this.search,
        page: this.currentPage,
        record_per_page: this.recordPerPage,
      };

      this.$http.post(url, payload).then((res) => {
        if (res.body.status) {
          this.alliedData = res.body.data.list;
          this.totalPage = Math.ceil(
            res.body.data.total_count / this.recordPerPage
          );
          this.total = res.body.data.total_count;
        }
      });
    },
    verifyDoctor(allied) {
      this.$refs.VerifyAlliedModal.viewModal(allied);
    },
    // showAlliedLogModal(data) {
    //   console.log("data", data.doctor);
    //   // this.$refs.AlliedLogModal.viewModal(data.doctor);
    // },
    viewAlliedDocument(data) {
      console.log("data", data);
      this.$refs.VerifyAlliedModal.viewModal(
        data.allied,
        data.fromLog,
        data.alliedObj
      );
    },
    moment(dateAndTime) {
      return moment(dateAndTime).format(formats.date_time_format);
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.$router.replace({
        path: "/allied-list",
        query: { page: this.currentPage },
      });
      this.getDoctors();
    },
    udpateRecordPerPage(perPage) {
      this.recordPerPage = perPage;
    },
    udpateStatus(status) {
      this.status = status;
    },
    checkRequestWasRejected(histories) {
      let truth = false;
      histories.forEach((history) => {
        if (history.current_document_status == "REJECT") {
          truth = true;
        }
      });
      return truth;
    },
    getViewDetails(allied) {
      this.userId = allied.allied_id._id;
      this.showAlliedProfile = true;
    },
    closeProfile() {
      this.showAlliedProfile = false;
    },
  },
  mounted() {
    this.currentPage = parseInt(
      this.$route.query.page ? this.$route.query.page : this.currentPage
    );
    this.getDoctors();
  },
};
</script>
